import React from "react";
import { gql } from "@apollo/client";
import { client } from "../App";
import InfiniteList from "./InfiniteList";
import { List, Radio, Button } from "antd";
import { logStatusIcon } from "../lib/status";
import { DownloadOutlined } from "@ant-design/icons";
import { migrationApiUrl } from "../lib/env";

export const MIGRATION_NOTIFICATION_FEED_QUERY = gql`
  query migrationNotificationFeed(
    $migrationId: ID!
    $offset: Int
    $limit: Int
    $queryString: String
    $logLevels: [String]
  ) {
    migrationNotificationFeed(
      migrationId: $migrationId
      offset: $offset
      limit: $limit
      queryString: $queryString
      logLevels: $logLevels
    ) {
      notifications {
        id
        level
        content
      }
      totalCount
      offset
      limit
      queryString
      logLevels
    }
  }
`;
export const DOWNLOAD_MIGRATION_NOTIFICATION_QUERY = gql`
  query generateMigrationNotificationCSV(
    $id: ID!
    $logLevels: [String]
    $queryString: String
  ) {
    generateMigrationNotificationCSV(
      id: $id
      logLevels: $logLevels
      queryString: $queryString
    ) {
      url
      bucket
      key
    }
  }
`;

type MigrationNotificationListProps = {
  migrationId: string | number;
};

export default class MigrationNotificationList extends React.Component<MigrationNotificationListProps> {
  state = {
    logLevels: [],
    downloading: false,
    queryString: "",
  };

  downloadMigrationNotifications = async () => {
    const { logLevels, queryString } = this.state;
    this.setState({ downloading: true });
    const { data } = await client.query({
      query: DOWNLOAD_MIGRATION_NOTIFICATION_QUERY,
      variables: { id: this.props.migrationId, logLevels, queryString },
    });
    const response = data.generateMigrationNotificationCSV;
    const downloadUrl = new URL(migrationApiUrl);
    downloadUrl.pathname = "s3/get/download";
    downloadUrl.searchParams.append("key", response.key);
    downloadUrl.searchParams.append("bucket", response.bucket);
    window.open(downloadUrl.toString());
    this.setState({ downloading: false });
  };

  onLevelButtonChange = (change) => {
    const level = change.target.value;
    if (level === "all") {
      this.setState({ logLevels: ["info", "warn", "error", "debug"] });
    } else {
      this.setState({ logLevels: [level] });
    }
  };

  logLevelButtons = (): JSX.Element => {
    return (
      <Radio.Group
        style={{ paddingLeft: 25 }}
        onChange={this.onLevelButtonChange}
        defaultValue="all"
      >
        <Radio.Button value="all">All</Radio.Button>
        <Radio.Button value="info">{logStatusIcon("info")} Info</Radio.Button>
        <Radio.Button value="warn">{logStatusIcon("warn")} Warn</Radio.Button>
        <Radio.Button value="error">
          {logStatusIcon("error")} Error
        </Radio.Button>
        <Radio.Button value="debug">
          {logStatusIcon("debug")} Debug
        </Radio.Button>
      </Radio.Group>
    );
  };

  onSearchChange = (searchString) => {
    this.setState({ queryString: searchString });
  };

  render() {
    const { logLevels, downloading } = this.state;
    return (
      <div>
        <div style={{ height: 30 }}>
          <div style={{ float: "right" }}>
            {this.logLevelButtons()}
            <span style={{ paddingLeft: 25 }}>
              <Button
                type="primary"
                loading={downloading}
                onClick={this.downloadMigrationNotifications}
                icon={<DownloadOutlined />}
              >
                Download
              </Button>
            </span>
          </div>
        </div>
        <InfiniteList
          query={MIGRATION_NOTIFICATION_FEED_QUERY}
          variables={{
            migrationId: this.props.migrationId,
            logLevels: logLevels,
            queryString: this.state.queryString,
          }}
          pollInterval={5000}
          recordKey="notifications"
          perPage={25}
          showSearch={true}
          onSearchChange={this.onSearchChange}
          listProps={{ style: { marginTop: 25 } }}
          renderListItem={(notification: any) => (
            <List.Item key={notification.id}>
              <span style={{ paddingLeft: 10, paddingRight: 25 }}>
                {logStatusIcon(notification.level)}
              </span>
              {notification.content}
            </List.Item>
          )}
        />
      </div>
    );
  }
}
